import { render, staticRenderFns } from "./TargetValue.vue?vue&type=template&id=40b63c88&scoped=true"
import script from "./TargetValue.vue?vue&type=script&lang=js"
export * from "./TargetValue.vue?vue&type=script&lang=js"
import style0 from "./TargetValue.vue?vue&type=style&index=0&id=40b63c88&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b63c88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40b63c88')) {
      api.createRecord('40b63c88', component.options)
    } else {
      api.reload('40b63c88', component.options)
    }
    module.hot.accept("./TargetValue.vue?vue&type=template&id=40b63c88&scoped=true", function () {
      api.rerender('40b63c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/TargetValue.vue"
export default component.exports